import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as AccountingCoinsIcon } from '../../assets/images/svg/accounting-coins.svg';
import themeColors from '../../assets/styles/themeColors';

const AccountingCoinsIconStyled = styled(AccountingCoinsIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundPrimaryDark};
`;

const AccountingCoins = (props) => <AccountingCoinsIconStyled {...props} />;

AccountingCoins.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

AccountingCoins.defaultProps = {
  w: '62px',
  h: '62px',
};

export default AccountingCoins;
